import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getPrecedingCatalog = state => state.models[name].data;
export const getCurPreceding = state => state.models[name].item;